import axios from '../shared/axios';
import * as events from './events';



export function create(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Assessment/Create`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}
export function update(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Assessment/Update`, data);
            events.onNotification_DRAFT_SAVED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}
export function communicate(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Assessment/Communicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}
export function get(assessmentid) {
    return axios.get(`/api/Assessment/Get`, { params: { assessmentid } });
}
export function deleteDraft(assessmentid) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`api/Assessment/DeleteDraft`, null, { params: { assessmentid } });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    })
}
export function getRegisterList(contractid, notificationtype, includedrafts, accessibleWfIds) {
    return axios.post(`/api/Assessment/RegisterList`, { accessibleWfIds }, { params: { contractid, notificationtype, includedrafts } });
}

export function importAssessments(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.post(`/api/Assessment/Import`, data);
            events.onNotification_CREATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function deleteAssessmentDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.delete(`/api/Assessment/BulkDeleteDraft`, { data: data });
            events.onNotification_DELETED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}

export function communicateAssessmentDrafts(data) {
    return new Promise(async (resolve, reject) => {
        try {
            const result = await axios.put(`/api/Assessment/BulkCommunicate`, data);
            events.onNotification_COMMUNICATED();
            resolve(result);
        }
        catch (err) {
            reject(err)
        }
    });
}